/**
 * file_name.js
 *
 * @경로 :
 * @목적 :
 * @설명 :
 * @진행 :
 * @주의 :
 * @이슈 :
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

import B_Define from 'canvas/base/dev/util/B_Define';
import B_HeaderTimer from "canvas/base/dev/child/tool/B_HeaderTimer";
import B_HeaderScore from "canvas/base/dev/child/tool/B_HeaderScore";
import B_HeaderTryCount from "canvas/base/dev/child/tool/B_HeaderTryCount";
import B_ToolJoyPad from "canvas/base/dev/child/tool/B_ToolJoyPad";
import B_ToolButton from "canvas/base/dev/child/tool/B_ToolButton";
import B_TryCount from "canvas/base/dev/child/attr/B_TryCount";
import B_ToolCountDown from "canvas/base/dev/child/tool/B_ToolCountDown";
import B_ToolPopup from "canvas/base/dev/child/tool/B_ToolPopup";
import B_ToolDisabled from "canvas/base/dev/child/tool/B_ToolDisabled";
import B_Util from "canvas/base/dev/util/B_Util";

const B_Tool = (function () {

	const $ = {
		_lc: null,        // {obj}
		timer: null,      // {obj}
		score: null,      // {obj}
		tryCount: null    // {obj}
	};

	class B_Tool extends createjs.Container {

		constructor(cm) {
			super();

			this.identification = B_Define.TOOL_TYPE; // [*] (필) container를 구분하는데 사용합니다.
			this.CODMOS = cm; // [S] canvas object
			this.CODMOS.WRAPPER.tool = {}; // [S] WRAPPER.tool

			// [S] tryCount
			this.addTryCount();

			// [S] countDown
			this.addCountDown();

			// [S] joy-pad
			if (typeof this.CODMOS.pad != 'undefined') this.addJoyPad(this.CODMOS.pad);

			// [S] button (bell)
			if (typeof this.CODMOS.btn != 'undefined') this.addButton(this.CODMOS.btn);

			// [S] header (timer, score, count)
			if (typeof this.CODMOS.header == 'object') {

				// [#] 화면에 보이는 Header의 전체 갯수
				const VISIBLE_COUNT = Object.values(this.CODMOS.header).filter((v) => {
					if(typeof v.visible == 'undefined' || v.visible == true) return true;
				}).length;

				// [#] 현재 visible index
				let visibleIndex = 1;
				const cWidth = this.CODMOS.CANVAS.width;
				Object.entries(this.CODMOS.header).forEach((keyValue)=>{
					if(typeof keyValue[1] == 'object') {

						// [#] default width
						if(typeof keyValue[1].w !== 'number') keyValue[1].w = B_Define.SHAPE_DEFAULT_WIDTH;

						/**
						 * VISIBLE_COUNT 가 3이라면 section은 총 3개가 됩니다.
						 *
						 * |=====|=====|=====|
						 * */
						const SECTION = cWidth / VISIBLE_COUNT;
						const PIXEL_X = (SECTION / 2) + SECTION * (visibleIndex - 1);

						if(keyValue[0] == 'timer') {
							this.addTimer(this.CODMOS.header.timer, PIXEL_X);
						}
						if(keyValue[0] == 'score') {
							this.addScore(this.CODMOS.header.score, PIXEL_X);
						}
						if(keyValue[0] == 'count') {
							this.addHeaderTryCount(this.CODMOS.header.count, PIXEL_X);
						}

						// [#] visibleIndex += 1
						if(typeof keyValue[1].visible == 'undefined' || keyValue[1].visible == true) visibleIndex += 1;
					}
				});
			}

			// [S] disabled (shpae)
			this.addDisabled();

			// [S] popup
			this.addPopup();
		}

		/**
		 * @DES :: 카운드다운 객체추가
		 * @S.E ::
		 */
		addCountDown() {
			this[B_Define.COUNTDOWN_ID] = new B_ToolCountDown({
				cm: this.CODMOS,
				id: B_Define.COUNTDOWN_ID,
				type: B_Define.TOOL_TYPE,
				text: "0",
				x: this.CODMOS.CANVAS.width * 1 / 2,
				y: this.CODMOS.CANVAS.height * 1 / 2
			});
			this[B_Define.COUNTDOWN_ID]._setPoint(50, 50);
			this.addChild(this[B_Define.COUNTDOWN_ID]._container);
			this.CODMOS.WRAPPER.tool[B_Define.COUNTDOWN_ID] = B_Util.getProtected(this[B_Define.COUNTDOWN_ID]);
		}

		/**
		 * [Function :: makeHeaderObject]
		 *
		 * @DES :: 'Header'의 Object를 생성하는 함수
		 * @IP1 :: className {class}
		 * @IP2 :: id {str}
		 * @O.P ::
		 * @S.E ::
		 */
		makeHeaderObject(className, id, width, pixelX){
			this[id] = new className({
				cm: this.CODMOS,
				id: id,
				type: B_Define.TOOL_TYPE,
				w: width,
				x: pixelX,
				y: B_Define.MARGIN_TOP
			});
			this[id]._setPoint(50, 50); // [#] 중심 설정
			this.addChild(this[id]._container); // [#] Canvas 추가
		}

		/**
		 * [Function:: addTimer]
		 *
		 * @DES :: 타이머 객체 추가
		 * @IP1 :: initJson {json}
		 * @IP2 :: pixelX {num}
		 * @O.P ::
		 * @S.E ::
		 */
		addTimer(initJson, pixelX) {
			// [#] timer 논리적으로 설정
			this.CODMOS.timer = initJson.timer;
			this.CODMOS.loopTimer();

			// [#] timer view 설정
			this.makeHeaderObject(B_HeaderTimer, B_Define.TIMER_ID, initJson.w, pixelX);
			this.CODMOS.WRAPPER.tool[B_Define.TIMER_ID] = B_Util.getProtected(this[B_Define.TIMER_ID]);
		}

		/**
		 * [Function:: addScore]
		 *
		 * @DES :: 스코어 객체 추가
		 * @IP1 :: initJson {json}
		 * @IP2 :: pixelX {num}
		 * @O.P :: null
		 * @S.E ::
		 */
		addScore(initJson, pixelX) {
			// [#] score view 설정
			this.makeHeaderObject(B_HeaderScore, B_Define.SCORE_ID, initJson.w, pixelX);
			this.CODMOS.WRAPPER.tool[B_Define.SCORE_ID] = B_Util.getProtected(this[B_Define.SCORE_ID]);
		}

		/**
		 * [Function:: addTryCount]
		 *
		 * @DES :: 시도횟수 객체 추가
		 * @IP1 :: null
		 * @O.P :: null
		 * @S.E ::
		 */
		addTryCount(){
			this[B_Define.TRY_COUNT_ID] = new B_TryCount();
			this.CODMOS.WRAPPER.tool[B_Define.TRY_COUNT_ID] = B_Util.getProtected(this[B_Define.TRY_COUNT_ID]);
		}

		/**
		 * [Function :: addHeaderTryCount]
		 *
		 * @DES ::
		 * @IP1 ::
		 * @O.P ::
		 * @S.E ::
		 */
		addHeaderTryCount(initJson, pixelX) {
			// [#] tryCount view 설정

			this[B_Define.TRY_COUNT_VIEW_ID] = new B_HeaderTryCount({
				cm: this.CODMOS,
				id: B_Define.TRY_COUNT_VIEW_ID,
				type: B_Define.TOOL_TYPE,
				w: initJson.w,
				x: pixelX,
				y: B_Define.MARGIN_TOP,
				max : initJson.max
			});
			this[B_Define.TRY_COUNT_VIEW_ID]._setPoint(50, 50); // [#] 중심 설정
			this.addChild(this[B_Define.TRY_COUNT_VIEW_ID]._container); // [#] Canvas 추가

			// this.makeHeaderObject(B_HeaderTryCount, B_Define.TRY_COUNT_VIEW_ID, initJson.w, pixelX);

			// [#] 외부에 노출될 필요 없음
			// this.CODMOS.WRAPPER.tool[B_Define.TRY_COUNT_VIEW_ID] = B_Util.getProtected(this[B_Define.TRY_COUNT_VIEW_ID]);
		}

		/**
		 * @DES :: 조이스틱 객체 추가
		 * @IP1 :: targetId {str} - 타겟 아이디
		 * @S.E ::
		 */
		addJoyPad(targetId) {
			const WIDTH = B_Define.JOYPAD_WIDTH;
			const HEIGHT = B_Define.JOYPAD_HEIGHT;
			const ROW = 2;
			const COLUMN = 3;
			this[B_Define.JOYPAD_ID] = new B_ToolJoyPad({
				cm: this.CODMOS,
				id: B_Define.JOYPAD_ID,
				type: B_Define.GRID_TYPE,
				target: targetId,
				row: ROW,
				column: COLUMN,
				w: WIDTH,
				h: HEIGHT,
				x: this.CODMOS.CANVAS.width * 1 / 2   - (WIDTH / 2),
				y: this.CODMOS.CANVAS.height - (HEIGHT * 3 / 4) - (HEIGHT / 2)
			});
			this[B_Define.JOYPAD_ID].toggleGrid();

			// [*] 그리드가 생성되기 전이라서 여기에다가 따로 초기화 처리했음...
			setTimeout(() => {
				this[B_Define.JOYPAD_ID]._initJoyPad(B_Define.JOYPAD_ID); // [S] init shape
				this[B_Define.JOYPAD_ID]._addClickListener(); // [S] add click
				this[B_Define.JOYPAD_ID]._addKeyDownListener(); // [S] add keyDown
			}, 100);
			this.addChild(this[B_Define.JOYPAD_ID]._container);
			this.CODMOS.WRAPPER.tool[B_Define.JOYPAD_ID] = B_Util.getProtected(this[B_Define.JOYPAD_ID]);
		}

		/**
		 * @DES :: 버튼 객체 추가
		 * @S.E ::
		 */
		addButton(obj) {
			let x, y;
			if (obj) {
				x = obj.x ? obj.x : this.CODMOS.CANVAS.width  * 1 / 2;
				y = obj.y ? obj.y : this.CODMOS.CANVAS.height * 4 / 5;
			}

			this[B_Define.BUTTON_ID] = new B_ToolButton({
				cm: this.CODMOS,
				id: B_Define.BUTTON_ID,
				res: B_Define.BUTTON_RES,
				type: B_Define.TOOL_TYPE,
				w: B_Define.BUTTON_WIDTH,
				h: B_Define.BUTTON_HEIGHT,
				x: x,
				y: y
			});
			this[B_Define.BUTTON_ID]._setArea();
			this[B_Define.BUTTON_ID]._setPoint(50, 50);
			this.addChild(this[B_Define.BUTTON_ID]._container);
			// this.CODMOS.WRAPPER.tool[B_Define.BUTTON_ID] = B_Util.getProtected(this[B_Define.BUTTON_ID]);
		}

		/**
		 * @DES :: disabled 객체 추가
		 * @S.E ::
		 */
		addDisabled() {
			this[B_Define.DISABLED_ID] = new B_ToolDisabled({
				cm : this.CODMOS,
				id : B_Define.DISABLED_ID,
				type : B_Define.TOOL_TYPE,
			});
			this.addChild(this[B_Define.DISABLED_ID]._container);
			this.CODMOS.WRAPPER.tool[B_Define.DISABLED_ID] = B_Util.getProtected(this[B_Define.DISABLED_ID]);
		}

		/**
		 * @DES ::
		 * @IP1 :: null
		 * @O.P :: null
		 * @S.E ::
		 */
		addPopup() {
			// [#] canvs popup dom 추가

			this[B_Define.POPUP_ID] = new B_ToolPopup({
				cm: this.CODMOS,
				id: B_Define.POPUP_ID,
				type: B_Define.TOOL_TYPE
			});
			this.addChild(this.popup._container);
			this.CODMOS.WRAPPER.tool[B_Define.POPUP_ID] = B_Util.getProtected(this[B_Define.POPUP_ID]);
		}

	}

	return B_Tool;
}());

export default B_Tool;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/frame/B_Tool.js